import BaseSocketClient from '@/utils/ws/baseSocketClient.js'
import { FUTURES_SOCKET_RECONNECT_EVENT } from '@/utils/constant.js'

class FuturesMSocket extends BaseSocketClient {
  static instance = null

  static autoConnect () {
    if (!this.instance) {
      this.instance = new FuturesMSocket()
    }
    return this.instance.connect()
  }

  static instanceClose () {
    if (!this.instance) {
      return
    }

    this.instance.isManualClose = true
    this.instance.closeRaw?.()
    this.instance.cleanup()
    this.instance = null
  }

  constructor () {
    super({
      wsUrl: wsFuturesUrl,
      reconnectEventName: FUTURES_SOCKET_RECONNECT_EVENT,
      logPrefix: 'futuresSocket'
    })
  }

  close () {
    FuturesMSocket.instanceClose()
  }
}

export default FuturesMSocket
